import React, { useEffect, useState } from 'react';
import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import useIsMounted from '../../../../components/hooks/useIsMounted';

const Report40Options = (props) => {
  const {
    handleOnSetFieldValue,
    handleOnSubmit,
    values,
  } = props;
  const isMounted = useIsMounted();
  const [reportOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="office" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="construction" />
      ),
      value: 1,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="industrial" />
      ),
      value: 2,
    },
  ]);

  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <AppMultiSelect
            icon={<AppRemixIcon icon="apps-2" />}
            options={reportOptions}
            title={ReactDOMServer.renderToString(
              <Translator file="module-comsaEnvironmental" name="sections" />
            )}
            placeholder={ReactDOMServer.renderToString(
              <Translator
                file="module-comsaEnvironmental"
                name="select.one.or.multiple.sections"
              />
            )}
            value={values?.sections || []}
            onChange={(v) => handleOnSetFieldValue('sections', v)}
            allowSelectAll
            isLoading={!reportOptions}
            hasSearchBox
            hasSelectOptions
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {!values.sections || values.sections.length === 0 ? (
            <span className="btn btn-info btn-block disabled">
              <Translator
                file="module-intelligence"
                name="module.int.btn.generate"
              />
            </span>
          ) : (
            <span
              className="btn btn-info btn-block"
              onClick={() => handleOnSubmit()}
            >
              <Translator
                file="module-intelligence"
                name="module.int.btn.generate"
              />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default Report40Options;
